import { render, staticRenderFns } from "./Reedemed.vue?vue&type=template&id=1b64fe18"
import script from "./Reedemed.vue?vue&type=script&lang=js"
export * from "./Reedemed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports